import { pathOr } from 'ramda';

import { IState } from '../../store';

export const getNewbuildingSpecifications = (state: IState) => {
  return pathOr([], ['offerData', 'newObject', 'specifications'], state);
};
